<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "primary-low", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper v-bind="props" viewBox="0 0 35 32">
    <g clip-path="url(#clip0_6780_4218)">
      <path
        d="M3.61746 14.6714C5.61533 14.6714 7.23492 13.0519 7.23492 11.054C7.23492 9.05612 5.61533 7.43652 3.61746 7.43652C1.61959 7.43652 0 9.05612 0 11.054C0 13.0519 1.61959 14.6714 3.61746 14.6714Z"
        :class="colorClass"
      />
      <path
        d="M4.48451 26.1539C6.63717 26.1539 8.38226 24.4088 8.38226 22.2561C8.38226 20.1035 6.63717 18.3584 4.48451 18.3584C2.33184 18.3584 0.586761 20.1035 0.586761 22.2561C0.586761 24.4088 2.33184 26.1539 4.48451 26.1539Z"
        :class="colorClass"
      />
      <path
        d="M14.2157 10.3882C17.0844 10.3882 19.4098 8.06269 19.4098 5.19408C19.4098 2.32547 17.0844 0 14.2157 0C11.3471 0 9.02167 2.32547 9.02167 5.19408C9.02167 8.06269 11.3471 10.3882 14.2157 10.3882Z"
        :class="colorClass"
      />
      <path
        d="M23.9822 7.87462C25.269 7.87462 26.3121 6.8315 26.3121 5.54473C26.3121 4.25797 25.269 3.21484 23.9822 3.21484C22.6955 3.21484 21.6523 4.25797 21.6523 5.54473C21.6523 6.8315 22.6955 7.87462 23.9822 7.87462Z"
        :class="colorClass"
      />
      <path
        d="M22.4142 29.2029C24.6298 29.2029 26.4258 27.4069 26.4258 25.1913C26.4258 22.9757 24.6298 21.1797 22.4142 21.1797C20.1986 21.1797 18.4026 22.9757 18.4026 25.1913C18.4026 27.4069 20.1986 29.2029 22.4142 29.2029Z"
        :class="colorClass"
      />
      <path
        d="M29.9994 18.3154C28.6943 20.0321 25.8126 20.6015 23.6054 19.3664C22.9835 19.0161 22.4317 18.5606 21.8448 18.1577C20.9864 17.5621 20.093 17.0453 19.0945 16.7125C17.5792 16.2044 16.2303 16.4322 15.0566 17.4482C14.1106 18.2716 13.3749 19.2613 12.9457 20.4526C12.4289 21.8803 12.7004 23.2116 13.6639 24.4379C14.1019 24.9985 14.6274 25.4714 15.1792 25.9094C16.8084 27.2232 16.9661 29.6933 15.5033 31.0772C14.2683 32.2421 12.3238 32.3122 10.9136 31.2436C9.3983 30.0874 9.04794 27.9152 10.1428 26.4349C10.607 25.813 11.0275 25.1736 11.2902 24.4291C11.7807 23.0365 11.5355 21.7489 10.6508 20.5314C10.1779 19.892 9.56472 19.3927 8.96911 18.8759C7.7341 17.8161 7.35746 16.038 8.08446 14.6541C8.89904 13.0862 10.8085 12.4118 12.4815 13.1388C12.9019 13.3227 13.2785 13.603 13.6552 13.8658C14.3559 14.3563 15.0829 14.7592 15.9237 14.9169C17.0099 15.1271 17.9821 14.8468 18.8755 14.2862C19.7251 13.7519 20.4346 13.0512 21.0915 12.2979C21.5032 11.8162 21.8799 11.2907 22.3528 10.879C23.9645 9.4863 25.8389 9.20602 27.8798 10.0381C29.9994 10.8965 31.287 12.9811 31.1994 15.2672C31.1644 16.3271 30.8053 17.2468 30.017 18.2978L29.9994 18.3154Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6780_4218">
        <rect width="35" height="32" fill="white" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
